import { render, staticRenderFns } from "./GameBoard.vue?vue&type=template&id=1eccae7e&scoped=true&"
import script from "./GameBoard.vue?vue&type=script&lang=ts&"
export * from "./GameBoard.vue?vue&type=script&lang=ts&"
import style0 from "./GameBoard.vue?vue&type=style&index=0&id=1eccae7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eccae7e",
  null
  
)

export default component.exports